import Vue from "vue";
import Vuex from "vuex";

import loader from "./loader";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    languageScreenIsOpen: false,
    imageReady: false,
    soundOn: false,
    videoOn: false,
    videoCode: ""
  },
  mutations: {
    setImageReady(state) {
      state.imageReady = true;
    },
    resetImageReady(state) {
      state.imageReady = false;
    },
    openLanguageSwitcher(state) {
      state.languageScreenIsOpen = true;
    },
    closeLanguageSwitcher(state) {
      state.languageScreenIsOpen = false;
    },
    handleAudioChange(state, value) {
      state.soundOn = value;
    },
    handleVideoChange(state, { value, video }) {
      state.videoOn = value;
      state.videoCode = video;
    }
  },
  actions: {},
  modules: {
    loader: loader
  },
  getters: {
    isImageReady: state => {
      return state.imageReady;
    }
  }
});
